import React, { useEffect, useContext } from "react"
import styled from "@emotion/styled"
import { Flex, Box } from "@rebass/grid/emotion"

import { TextElementNova } from "@nutrafol/nutrafol-ui-kit/dist/TextElementNova"
import { ResultsContext } from "../resultscontext/resultscontext"

import { NextArrow, PrevArrow } from "../resultsarrows/resultsarrows"

const Wrapper = styled(Flex)`
  align-items: center;
  margin: 0 auto;
  justify-content: space-between;

  @media (min-width: 768px) {
    justify-content: center;
  }

  p {
    line-height: 1 !important;
  }
`

const PaginationWrapper = styled(Box)`
  position: relative;
  width: 100%;
  text-align: center;
`

const Pagination = ({ slidesCount }) => {
  const resultsContext = useContext(ResultsContext)
  const {
    autoplay,
    setAutoplay,
    resultSliderRef,
    currentItemIndex,
    goToSlide,
  } = resultsContext

  const prevSlide = () => {
    goToSlide(currentItemIndex - 1)
    setAutoplay(false)
  }

  const nextSlide = () => {
    goToSlide(currentItemIndex + 1)
    setAutoplay(false)
  }

  useEffect(() => {
    if (!autoplay) {
      resultSliderRef?.slickPause()
    }
  }, [autoplay, resultSliderRef])

  return (
    <Wrapper className="md:!hidden">
      <Box>
        <PrevArrow onClick={prevSlide} />
      </Box>
      <PaginationWrapper>
        <TextElementNova
          text={`${currentItemIndex + 1} / ${slidesCount}`}
          className="Body-10-Dia-Normal"
        />
      </PaginationWrapper>
      <Box>
        <NextArrow onClick={nextSlide} />
      </Box>
    </Wrapper>
  )
}

export default Pagination
